export const colorOverrides = {
  text: {
    body: "#3D3D3D",
    inverse: "#FFFFFF",
    label: "#2E2E2E",
    helper: "#848484",
    placeholder: "#A0A0A0",
    description: "#474747",
    danger: "#C03434",
    success: "#00774E",
    title: {
      brand: "#2164DA",
      brandSecondary: "#3C4764",
      alt: "#2E2E2E",
    },
    link: {
      disabled: "#A0A0A0",
      default: "#2164DA",
      hover: "#0D4FCA",
      dark: "#3D3D3D",
    },
  },
  icon: {
    warning: "#E2B73E",
    default: "#276EF1",
    alt: "#686868",
    danger: "#C03434",
  },
}
